<template>
    <div>
        <v-card elevation="0">
            <v-alert type="info">This may not reflect the exact view of the user.</v-alert>
            <v-card-title> <v-icon color="#01579B">mdi-finance</v-icon>&nbsp;{{ username }}'s Financial Analysis</v-card-title>
            <v-card-text>
                <div>
                    <v-row>
                        <v-col md="4">
                            <v-card elevation="0" color="#E1F5FE" height="500">
                                <v-card-text>
                                    <div style="color: black;">Last Updated: {{ lastUpdated }}</div> <br />
                                    <v-select
                                        v-model="selectedBudget"
                                        hint="Select Budget Type you would like to view"
                                        :items="budgetTypes"
                                        item-text="label"
                                        item-value="prefix"
                                        label="Budget Type"
                                        persistent-hint
                                        outlined
                                        return-object
                                        @change="changeView()"
                                    ></v-select><br />
                                    <div v-if="graphRender">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <tbody>
                                                    <tr>
                                                        <th class="text-left" colspan="2" style="color: white; background-color: #01579B;"> {{ selectedBudget.label }} </th>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left">
                                                            Budget
                                                        </th>
                                                        <td>$ {{ chosenfaData.budget }}</td>
                                                    </tr>
                                                    <tr>
                                                        <th class="text-left">
                                                            Actual
                                                        </th>
                                                        <td>$ {{ chosenfaData.actual }}</td>
                                                     </tr>
                                                    <tr>
                                                        <th class="text-left">
                                                             Available
                                                        </th>
                                                        <td>$ {{ chosenfaData["available-real"] }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col md="7">
                            <v-card elevation="0" outlined height="500">
                                <v-card-text>
                                    <DoughnutChart :faData="chosenfaData" :budgetType="selectedBudget" v-if="graphRender"/>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import DoughnutChart from "../FinancialAnalysis/DoughnutChart.vue";
export default {
    components: {
        DoughnutChart
    },
    props: {
        username: {
            required: true
        },
        lastUpdated: {
            required: true
        },
        faData: {
            required: true
        },
    },
    data(){
        return {
            budgetTypes: [],
            selectedBudget: "",
            chosenfaData: [],
            graphRender: false
        }
    },
    methods: {
        checkData(){
            const that = this;
            
            that.budgetTypes = that.faData.budgets;
            that.selectedBudget = that.faData.budgets[0];
            that.changeView();
        },
        changeView(){
            const that = this;
            that.graphRender = false;
            that.chosenfaData = [];

            setTimeout(function() {
                //Re-renders the view with the new data
                that.setBudgetDataValue(that.selectedBudget.prefix);

                that.graphRender = true;
            }, 300);

        },
        setBudgetDataValue(budgetType){
            //I have read that .toFixed() may be buggy sometimes, but I believe it will be okay for 99.99% for our cases.
            const that = this;
            var available = 0.00;

            if(parseFloat(that.faData[budgetType+"-available"]) < parseFloat(0)){
                available = parseFloat(0).toFixed(2);
            }else {
                available = parseFloat(that.faData[budgetType+"-available"]).toFixed(2);
            }

            var data = {
                        "budget": parseFloat(that.faData[budgetType+"-budget"]).toFixed(2),
                        "actual": parseFloat(that.faData[budgetType+"-actual"]).toFixed(2),
                        "available": available,
                        "available-real" : parseFloat(that.faData[budgetType+"-available"]).toFixed(2)
                }

            that.chosenfaData = data;
        }
    },
    created(){
        const that = this;
        that.checkData();
    }
}
</script>
<style scoped>
h3{
    background-color: #004236;
    color: white;
    padding-left: 5px;
}
</style>